import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const MassageIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "MassageIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M22.0826 13.7259H21.1878C20.6654 11.1054 19.3765 8.61652 17.3814 6.6322C16.976 6.22908 16.4056 6.05824 15.8416 6.16626C16.3929 5.7351 16.7482 5.06462 16.7482 4.31217C16.7482 3.01441 15.6925 1.95874 14.3948 1.95874C13.097 1.95874 12.0413 3.01441 12.0413 4.31217C12.0413 5.60993 13.097 6.6656 14.3948 6.6656C14.5965 6.6656 14.7925 6.64001 14.9794 6.59206C14.7559 6.79339 14.5843 7.05156 14.4853 7.3485L13.5 10.3042L11.453 11.6688C11.0607 11.9303 10.7937 12.329 10.7013 12.7913C10.6378 13.1083 10.6617 13.4291 10.7673 13.7259H10.2764C9.80496 13.7259 9.3617 13.9096 9.02829 14.243L7.19182 16.0793H4.35345C3.38021 16.0793 2.58838 16.8712 2.58838 17.8444V21.453C2.58838 21.778 2.85176 22.0413 3.17674 22.0413H22.0826C22.4076 22.0413 22.671 21.778 22.671 21.453V14.3142C22.671 13.9893 22.4076 13.7259 22.0826 13.7259ZM13.218 4.31217C13.218 3.66329 13.7459 3.13545 14.3948 3.13545C15.0436 3.13545 15.5715 3.66329 15.5715 4.31217C15.5715 4.96105 15.0436 5.48889 14.3948 5.48889C13.7459 5.48889 13.218 4.96105 13.218 4.31217ZM12.1057 12.648L14.3206 11.1713C14.4295 11.0986 14.511 10.992 14.5524 10.8679L15.6017 7.72066C15.7366 7.3157 16.2568 7.17336 16.5516 7.46662C18.2896 9.19507 19.468 11.3476 19.986 13.7259H18.782C18.4561 12.3693 17.8901 11.0988 17.0943 9.94339C16.9677 9.75968 16.7479 9.66346 16.5271 9.69472C16.3063 9.72598 16.122 9.87965 16.0515 10.0913L15.4775 11.8142L12.7584 13.6269C12.4884 13.8069 12.1224 13.7337 11.9425 13.4637C11.7626 13.1939 11.8357 12.8279 12.1057 12.648ZM16.2983 12.6812C16.4071 12.6086 16.4888 12.5018 16.5302 12.3777L16.7653 11.6717C17.1073 12.3249 17.3758 13.0114 17.5684 13.7259H14.7314L16.2983 12.6812ZM4.35345 17.256H7.43559C7.59172 17.256 7.74126 17.194 7.85158 17.0837L9.86027 15.075C9.97151 14.9639 10.1192 14.9022 10.2764 14.9022H21.4943V16.0793H10.7635C10.6074 16.0793 10.4578 16.1414 10.3475 16.2517L8.16629 18.4328H4.35346C4.0291 18.4328 3.7651 18.1688 3.7651 17.8444C3.7651 17.52 4.02908 17.256 4.35345 17.256ZM3.76509 20.8646V19.5083C3.94926 19.5736 4.14722 19.6095 4.35345 19.6095H8.41005C8.56603 19.6095 8.71572 19.5474 8.82604 19.4371L11.0072 17.256H21.4943V20.8646L3.76509 20.8646Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default MassageIcon;
